import { OrganType } from '@/api/apis/case';
import { Hub } from '@/api/apis/facilities';
import { UserRole } from '@/api/apis/user';

export enum FilterResourceType {
  TXContacts = 'txContacts',
  OpoContacts = 'opoContacts',
  TmdxContacts = 'tmdxContacts',
  Devices = 'devices',
}

export enum FilterKey {
  ResourceType = 'resourceType',
  TxCenterContact = 'txCenterContact',
  TmdxUser = 'tmdxUser',
  SurgeonType = 'surgeonType',
  AffiliationType = 'affiliationType',
}

export type ResourceRowData = {
  id: string;
  userId?: string;
  firstName?: string;
  lastName?: string;
  photoPath?: string;
  primaryPhone?: string;
  secondaryPhone?: string;
  roles?: UserRole[];
  assigned: boolean;
  canAssign?: boolean;
  canDetach?: boolean;
  organSpecializations?: OrganType[];
  baseLocation?: Hub | null;
  homeLocation?: string;
  affiliationOpoName?: string;
  displayOpoAffiliationInNameColumn?: boolean;
};

export type ResourceRowDataWithRoles = Omit<ResourceRowData, 'roles'> & {
  roles: UserRole[];
};
